/** Fallback app name. The live name comes from `config.appName` (/api/auth/me). */
export const APP_NAME = "INaAI - Drive Management";

interface BrandMarkProps {
  className?: string;
}

/**
 * Inline, dependency-free brand glyph (generic folder/box). Uses currentColor so
 * callers tint it (default text-brand-600). No external asset.
 */
export function BrandMark({ className = "h-6 w-6 text-brand-600" }: BrandMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 7.5A1.5 1.5 0 0 1 4.5 6h4.382a1.5 1.5 0 0 1 1.06.44l1.118 1.12a1.5 1.5 0 0 0 1.06.44H19.5A1.5 1.5 0 0 1 21 9.5v8A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5v-10Z" />
    </svg>
  );
}
